import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useStatsigClient } from '@statsig/react-bindings';

import { QUESTION_TYPES } from '@api/instant_survey';
import { GATES } from '@constants';
import { OverlayTriggerTooltip } from '@utilities';

import styles from './_index.module.scss';

const additionalQuestionTypes = [
  QUESTION_TYPES.INSTRUCTIONS,
  QUESTION_TYPES['RANK-DRAGDROP'],
  QUESTION_TYPES['TABLE-RADIO'],
  QUESTION_TYPES.TURF,
];
const Sidebar = ({ allowedQuestionTypes, isVideoSurvey, onSelectQuestionType, question }) => {
  const { client } = useStatsigClient();
  const requireQuestionTypeSelection = client.checkGate(GATES.REQUIRE_QUESTION_TYPE_SELECTION);
  const commonQuestionTypes = requireQuestionTypeSelection
    ? [QUESTION_TYPES.RADIO, QUESTION_TYPES.CHECKBOX, QUESTION_TYPES.ESSAY]
    : [QUESTION_TYPES.CHECKBOX, QUESTION_TYPES.RADIO, QUESTION_TYPES.ESSAY];

  const isQuestionTypeAllowed = (type) =>
    !allowedQuestionTypes ||
    allowedQuestionTypes.some((allowedType) => allowedType.value === type.value);
  const filteredCommonQuestionTypes = commonQuestionTypes.filter(isQuestionTypeAllowed);
  const filteredAdditionalQuestionTypes = additionalQuestionTypes.filter(isQuestionTypeAllowed);

  const renderQuestionTypeButton = (type) => {
    return (
      <OverlayTriggerTooltip
        content={type.value === question.type ? null : type.description}
        placement="right"
      >
        <button
          aria-pressed={type.value === question.type}
          className={classNames({
            [styles['is-active']]: type.value === question.type,
          })}
          data-testid={type.value}
          onClick={() => onSelectQuestionType(type.value)}
        >
          {type.icon}
          <span>{type.name}</span>
        </button>
      </OverlayTriggerTooltip>
    );
  };

  return (
    <div className={styles['sidebar']}>
      <h4>Common Question Types</h4>
      {isVideoSurvey ? (
        <ul>
          {isQuestionTypeAllowed(QUESTION_TYPES.VIDEO) && (
            <li key={QUESTION_TYPES.VIDEO.value}>
              {renderQuestionTypeButton(QUESTION_TYPES.VIDEO)}
            </li>
          )}
        </ul>
      ) : (
        <>
          <ul>
            {filteredCommonQuestionTypes.map((type) => (
              <li key={type.value}>{renderQuestionTypeButton(type)}</li>
            ))}
          </ul>
          <hr />
          <h4>Additional Question Types</h4>
          <ul>
            {filteredAdditionalQuestionTypes.map((type) => (
              <li key={type.value}>{renderQuestionTypeButton(type)}</li>
            ))}
            {isQuestionTypeAllowed(QUESTION_TYPES.CONTSUM) && (
              <li>{renderQuestionTypeButton(QUESTION_TYPES.CONTSUM)}</li>
            )}
            {isQuestionTypeAllowed(QUESTION_TYPES.MAX_DIFF) && (
              <li>{renderQuestionTypeButton(QUESTION_TYPES.MAX_DIFF)}</li>
            )}
            {isQuestionTypeAllowed(QUESTION_TYPES.NUMERIC) && (
              <li>{renderQuestionTypeButton(QUESTION_TYPES.NUMERIC)}</li>
            )}
          </ul>
        </>
      )}
    </div>
  );
};

Sidebar.propTypes = {
  allowedQuestionTypes: PropTypes.arrayOf(PropTypes.object),
  isVideoSurvey: PropTypes.bool.isRequired,
  onSelectQuestionType: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
};

export default Sidebar;
